/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useAuth } from "cms/auth/hooks/use-auth";
import { useAsyncFn } from "react-use";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { pageDefaults } from "./config";

export function useFormSearch () {
    const { token } = useAuth();

    const [{ loading, error, value }, searchForms] = useAsyncFn(
        /**
         * @param {string=} search
         * @param {object=} _pagination 
         * @param {number} _pagination.page
         * @param {number} _pagination.pageSize
         */
        async (search = "", _pagination = {}) => {
            let params;
            if (Object.keys(_pagination).length) {
                params = {
                    page: _pagination.page,
                    pageSize: _pagination.pageSize,
                };
            } else {
                params = pageDefaults;
            }

            /** @type {FormSearchResults} */
            const result = await SimpliCityAdminSDK.form.search(
                token,
                search,
                params
            );

            return result;
        },
        [token]
    );
    
    const forms = value?.results || [];

    return {
        loading,
        error,
        forms,
        searchForms
    };
}

/**
 * @typedef {object} FormSearchResults
 * @property {object} pagination
 * @property {any[]} results
 */
